import React, { memo } from 'react'
//SCSS
import classes from './GraphicCarousel.module.scss'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import DBSData from 'Data/DBSData.js';
import "./CarouselOverride.scss"

//COMPONENTS
import { Carousel } from 'react-responsive-carousel';
import HeroGraphic from 'Components/HeroGraphic/HeroGraphic';


function GraphicCarousel({carouselData}){

    let carouselMarkup = Object.keys(carouselData).map((item, index) => 
    <div key={index} className={classes.graphic_carousel__container}>
        <div className={classes.graphic_carousel__image}>{carouselData[item].icon}</div>
        <h5 dangerouslySetInnerHTML={{__html: carouselData[item].title}}></h5>
        <h5>{carouselData[item].description}</h5>
    </div>
)

    return (
        <div className={classes.graphic_carousel}>
            <Carousel showThumbs={false} showStatus={false}>
               <div className={classes.graphic_carousel__start}>
                    {<HeroGraphic heroGraphicSmallTitle={DBSData.INTRO_PANEL.smallTitle} heroGraphicTitle={DBSData.INTRO_PANEL.title} heroGraphicIcon={DBSData.INTRO_PANEL.icon}/>}
               </div> 
                    {carouselMarkup}
            </Carousel>
            
        </div>
    )

}

export default memo( GraphicCarousel )